interface ChipMultiSelectProps<T extends string> {
  /** Optional caption shown above the chip row. */
  label?: string;
  options: readonly T[];
  selected: readonly T[];
  onToggle: (value: T) => void;
  /** Map a raw enum value to its staff-facing label. */
  getLabel: (value: T) => string;
  columns?: number;
}

/**
 * A wrapping group of tappable pills for a small multi-select - the compact
 * alternative to a long checkbox list. Selected chips fill with the theme color.
 * Shared by the reservation create form and edit popup (occasion / seating).
 */
export default function ChipMultiSelect<T extends string>({
  label,
  options,
  selected,
  onToggle,
  getLabel,
  columns,
}: ChipMultiSelectProps<T>) {
  return (
    <div className="rsv-chip-group">
      {label && <div className="rsv-chip-label">{label}</div>}
      <div
        className={`rsv-chip-row${columns ? ' rsv-chip-row--grid' : ''}`}
        style={columns ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined}
      >
        {options.map((value) => (
          <button
            type="button"
            key={value}
            className={`rsv-chip${columns ? ' rsv-chip--cell' : ''}${selected.includes(value) ? ' rsv-chip--on' : ''}`}
            onClick={() => onToggle(value)}
          >
            {getLabel(value)}
          </button>
        ))}
      </div>
    </div>
  );
}
